import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-619a7d9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-tachometer-alt me-2" }, null, -1))
const _hoisted_5 = { class: "card-subtitle text-muted" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "list-group list-group-flush" }
const _hoisted_8 = { class: "list-group-item p-0" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "list-group list-group-flush" }
const _hoisted_12 = { class: "list-group-item" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการที่ดำเนินการ:", -1))
const _hoisted_15 = { class: "col text-end" }
const _hoisted_16 = { class: "list-group-item" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการที่ยกเลิก:", -1))
const _hoisted_19 = { class: "col text-end" }
const _hoisted_20 = { class: "list-group-item" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการทั้งหมด:", -1))
const _hoisted_23 = { class: "col text-end" }
const _hoisted_24 = { class: "list-group-item p-0" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md" }
const _hoisted_27 = { class: "list-group list-group-flush" }
const _hoisted_28 = { class: "list-group-item" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบกลาง/เหลือจ่ายที่ได้รับ:", -1))
const _hoisted_31 = { class: "col text-end" }
const _hoisted_32 = { class: "list-group-item" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ใช้จริง:", -1))
const _hoisted_35 = { class: "col text-end" }
const _hoisted_36 = { class: "list-group-item" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ยังไม่นำมาคำนวณ:", -1))
const _hoisted_39 = { class: "col text-end" }
const _hoisted_40 = { class: "list-group-item" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบยกเลิก/ส่วนต่าง/ส่งคืน:", -1))
const _hoisted_43 = { class: "col text-end" }
const _hoisted_44 = { class: "col-md" }
const _hoisted_45 = { class: "list-group list-group-flush" }
const _hoisted_46 = { class: "list-group-item" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ต้องเบิกจ่าย:", -1))
const _hoisted_49 = { class: "col text-end" }
const _hoisted_50 = { class: "list-group-item" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่เบิกจ่ายไปแล้ว:", -1))
const _hoisted_53 = { class: "col text-end" }
const _hoisted_54 = { class: "list-group-item" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ส่งคืน:", -1))
const _hoisted_57 = { class: "col text-end" }
const _hoisted_58 = { class: "list-group-item" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ยังไม่ได้เบิกจ่าย:", -1))
const _hoisted_61 = { class: "col text-end" }
const _hoisted_62 = { class: "card" }
const _hoisted_63 = { class: "card-header" }
const _hoisted_64 = { class: "card-title" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-line me-2" }, null, -1))
const _hoisted_66 = { class: "card-body" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-sm-6" }
const _hoisted_69 = { class: "card" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-bar me-2" }),
    /*#__PURE__*/_createTextVNode("จำนวนโครงการ")
  ])
], -1))
const _hoisted_71 = { class: "card-body" }
const _hoisted_72 = { class: "col-sm-6" }
const _hoisted_73 = { class: "card" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-pie me-2" }),
    /*#__PURE__*/_createTextVNode("จำนวนโครงการแยกตามประเภทโครงการ")
  ])
], -1))
const _hoisted_75 = { class: "card-body" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col" }
const _hoisted_78 = { class: "col d-flex align-items-center" }
const _hoisted_79 = { class: "list-group list-group-flush w-100" }
const _hoisted_80 = { class: "ms-2 me-auto" }
const _hoisted_81 = { class: "badge bg-secondary rounded-pill" }
const _hoisted_82 = { class: "col-sm-6" }
const _hoisted_83 = { class: "card" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-bar me-2" }),
    /*#__PURE__*/_createTextVNode("งบประมาณที่ได้รับ")
  ])
], -1))
const _hoisted_85 = { class: "card-body" }
const _hoisted_86 = { class: "col-sm-6" }
const _hoisted_87 = { class: "card" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-bar me-2" }),
    /*#__PURE__*/_createTextVNode("งบประมาณที่ได้รับแยกตามประเภทโครงการ")
  ])
], -1))
const _hoisted_89 = { class: "card-body" }
const _hoisted_90 = { class: "col-sm-6" }
const _hoisted_91 = { class: "card" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-bar me-2" }),
    /*#__PURE__*/_createTextVNode("งบประมาณที่เบิกจ่าย")
  ])
], -1))
const _hoisted_93 = { class: "card-body" }
const _hoisted_94 = { class: "col-sm-6" }
const _hoisted_95 = { class: "card" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chart-bar me-2" }),
    /*#__PURE__*/_createTextVNode("ร้อยละของผลดำเนินการ")
  ])
], -1))
const _hoisted_97 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultProjectTypeComponent = _resolveComponent("ResultProjectTypeComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_LineChartComponent = _resolveComponent("LineChartComponent")!
  const _component_BarChartComponent = _resolveComponent("BarChartComponent")!
  const _component_DoughnutChartComponent = _resolveComponent("DoughnutChartComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, [
          _hoisted_4,
          _createTextVNode("ผลการดำเนินการโครงการของ" + _toDisplayString(_ctx.fiscalYear?.name), 1)
        ]),
        _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.description), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.projectCount).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '?') + " โครงการ", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.cancelProjectCount).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '?') + " โครงการ", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalProjectCount).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '?') + " โครงการ", 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalRealBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalUncalBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalResidual).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("ul", _hoisted_45, [
                  _createElementVNode("li", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalRealBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalReturnBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, _toDisplayString(!_ctx.isLoading ? Number(_ctx.summary?.totalRealBudget - _ctx.summary?.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '?') + " บาท", 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ResultProjectTypeComponent, {
      "fiscal-year": _ctx.fiscalYear,
      mode: _ctx.mode,
      target: _ctx.target
    }, null, 8, ["fiscal-year", "mode", "target"]),
    (_ctx.chart)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("h5", _hoisted_64, [
                _hoisted_65,
                _createTextVNode("การเบิกจ่ายงบประมาณของ" + _toDisplayString(_ctx.fiscalYear?.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                : (_openBlock(), _createBlock(_component_LineChartComponent, {
                    key: 1,
                    "chart-data": _ctx.chart?.periods
                  }, null, 8, ["chart-data"]))
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_BarChartComponent, {
                        key: 1,
                        "chart-data": _ctx.chart?.projects
                      }, null, 8, ["chart-data"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_DoughnutChartComponent, {
                            key: 1,
                            "chart-data": _ctx.chart?.projectTypes
                          }, null, 8, ["chart-data"]))
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("ul", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chart?.projectTypes.labels, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item,
                            class: "list-group-item d-flex justify-content-between align-items-start"
                          }, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("span", {
                                class: "fas fa-circle me-2",
                                style: _normalizeStyle({color: _ctx.chart?.projectTypes?.datasets[0].backgroundColor[index]})
                              }, null, 4),
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _createElementVNode("span", _hoisted_81, _toDisplayString(Number(_ctx.chart?.projectTypes.datasets[0].data[index]).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_BarChartComponent, {
                        key: 1,
                        "chart-data": _ctx.chart?.budgets
                      }, null, 8, ["chart-data"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_BarChartComponent, {
                        key: 1,
                        "chart-data": _ctx.chart?.budgetProjectTypes
                      }, null, 8, ["chart-data"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _hoisted_92,
                _createElementVNode("div", _hoisted_93, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_BarChartComponent, {
                        key: 1,
                        "chart-data": _ctx.chart?.spents
                      }, null, 8, ["chart-data"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _hoisted_96,
                _createElementVNode("div", _hoisted_97, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_BarChartComponent, {
                        key: 1,
                        "chart-data": _ctx.chart?.percents
                      }, null, 8, ["chart-data"]))
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}